//import createHistory from 'history/createBrowserHistory';
//export const history = createHistory();
import { createBrowserHistory } from "history";
export const history = createBrowserHistory();
